import { useState, useRef } from "react";
import { BlobLoader } from "../../components/loader";

function VideoPlayer({ src, resumeTime, onPause, onEnded }) {
  const videoRef = useRef(null);

  const [isPlaying, setIsPlaying] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const togglePlay = () => {
    const video = videoRef.current;
    if (!video) return;

    if (video.paused || video.ended) {
      video.play();
    } else {
      video.pause();
    }
  };

  const handlePlay = () => setIsPlaying(true);

  const handlePause = () => setIsPlaying(false);

  return (
    <div style={{ position: "relative", width: "100%" }}>
      {/* Loader */}
      {isLoading && (
        <div
          className="content-loader"
          style={{
            position: "absolute",
            inset: 0,
            zIndex: 20,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "#fff",
          }}
        >
          <BlobLoader />
        </div>
      )}

      <video
        ref={videoRef}
        className="scroll video-wrapper"
        style={{
          border: 0,
          width: "100%",
          visibility: isLoading ? "hidden" : "visible",
        }}
        controls
        preload="auto"
        playsInline
        controlsList="nodownload"
        onLoadedMetadata={(e) => {
          if (resumeTime > 0 && resumeTime < e.target.duration) {
            e.target.currentTime = resumeTime;
          }
        }}
        onCanPlay={() => {
          setIsLoading(false);
        }}
        onPlay={handlePlay}
        onPause={(e) => {
          handlePause();
          onPause?.(e);
        }}
        onEnded={(e) => {
          handlePause();
          onEnded?.(e);
        }}
      >
        <source src={src} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {!isPlaying && !isLoading && (
        <div className="play-button-wrapper">
          <div
            title="Play video"
            className="play-gif"
            onClick={togglePlay}
            style={{ cursor: "pointer" }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80">
              <path d="M40 0a40 40 0 1040 40A40 40 0 0040 0zM26 61.56V18.44L64 40z" />
            </svg>
          </div>
        </div>
      )}
    </div>
  );
}

export default VideoPlayer;